import * as React from 'react'

import _ from 'lodash'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import createComputed from 'modules/core/hooks/createComputed'
import i18n from 'modules/core/lib/i18n'

import CoreMarketRegions from 'modules/locations/components/CoreMarketsRegions'
import type ImportPublicHolidaysForm from 'modules/locations/lib/forms/ImportPublicHolidays'
import type PublicHoliday from 'modules/locations/store/models/PublicHoliday'

interface Props {
  form: ImportPublicHolidaysForm
  publicHolidays: PublicHoliday[]
  onChange: () => void
}

const COREMARKETS = ['es', 'fr', 'gb', 'de', 'it', 'pt', 'br', 'us', 'mx', 'ch']

function cityToLowerCase(holiday: PublicHoliday): string | null | undefined {
  const city = holiday.attributes.city

  return city ? city.toLowerCase() : null
}

const getCities = createComputed((holidays: PublicHoliday[]) => {
  return _.uniq(_.compact(holidays.map((h) => cityToLowerCase(h)))).map((city) => ({
    value: city,
    label: _.capitalize(city),
  }))
})

const RegionsAndCitiesRow = ({ form, publicHolidays, onChange }: Props) => {
  const holidays = form.matchingHolidaysNotEmpty(publicHolidays)
  const cities = getCities(holidays).get()
  const country = form.get('country').value
  const coreMarkets = COREMARKETS.find((e) => e === country)

  if (!coreMarkets) return null

  return (
    <FormRow multi={!!cities.length}>
      <CoreMarketRegions
        label={i18n.t('settings.time_off.region')}
        field={form.get('region')}
        none={i18n.t('common.choose')}
        country={country}
        onChange={onChange}
      />
      {!!cities.length && (
        <Select
          label={i18n.t('settings.time_off.city')}
          options={cities}
          field={form.get('city')}
          none={i18n.t('common.choose')}
          showOriginalLabelText
          onChange={onChange}
        />
      )}
    </FormRow>
  )
}

export default observer(RegionsAndCitiesRow)
